export default class Confirm {


  confirm(params={}) 
  {
    return new Promise((resolve, reject) => {
      Swal.fire(params).then((result) => {
        if (result.isConfirmed) {
          resolve('delete confirmed')
        } else {
          reject('delete rejected');
        }
      });
    });
  }


  /**
   * Show a warning confirm
   */
  warning(title, text, btn) 
  {
    const options = {
      title:title,
      text:text,
      icon:'warning',
      showCancelButton: true,
      confirmButtonColor: '#f5a115',
      cancelButtonColor: '#d33',
      confirmButtonText: btn,
      cancelButtonText: 'Cancel'
    }
    return this.confirm(options);
  }

  /**
   * Show an info confirm
   */
  info(title, text, btn) 
  {
    const options = {
      title:title,
      text:text,
      icon:'info',
      showCancelButton: true,
      confirmButtonColor: '#f5a115',
      cancelButtonColor: '#d33',
      confirmButtonText: btn,
      cancelButtonText: 'Cancel'
    }
    return this.confirm(options);
  }

  /**
   * Show a delete confirm
   */
  delete(title, text, btn) 
  {
    const options = {
      title:title,
      text:text,
      icon:'warning',
      showCancelButton: true,
      confirmButtonColor: '#f5a115',
      cancelButtonColor: '#d33',
      confirmButtonText: btn,
      cancelButtonText: 'Cancel'
    }
    return this.confirm(options);
  }


}